import * as React from 'react';
import { QueryCondition, User, Query, QueryFilter, AuditTrailEvent, QueryOrderDirection } from '../misc/api/apiTypes';
import { useWebPortalLegacyClient } from '../misc/api/WebPortalTokenClient';
import MultiSelectModal from '../misc/components/queryTable/MultiSelectModal';

const AuditTrailActionKey = "Name";
const AuditTrailActionFilterQueryCondition = QueryCondition.Equal;
export const AuditTrailActionHeader = "Audit Trail Action";

interface UserFilterProps {
    filterMember: string;
    onClose: (member: string, condition: QueryCondition, values: string[]) => void;
    query: Query<User>;
}

const AuditTrailActionFilterModal = ({ filterMember, onClose, query }: UserFilterProps): JSX.Element => {
    const legacyClient = useWebPortalLegacyClient();

    const GetQueryFilter = (query: Query<User>): QueryFilter => {
        return query.Filters.find(filter => filter.Member === filterMember && filter.Condition === AuditTrailActionFilterQueryCondition);
    }

    const queryFilter = GetQueryFilter(query) || { Values: [] };

    const [values, setValues] = React.useState<string[]>(queryFilter.Values as string[]);

    const [allActions, setAllActions] = React.useState<AuditTrailEvent[]>(null);

    React.useEffect(() => {
        legacyClient.getAuditTrailActions({
            Order: {
                Direction: QueryOrderDirection.Ascending,
                Member: AuditTrailActionKey
            }
        }).then(actionsResult => {
            setAllActions(actionsResult.Data);
        });
    }, []);

    return (<MultiSelectModal header={AuditTrailActionHeader + ' Filter'}
        isLoading={!allActions}
        show={true}
        options={allActions}
        valueKey={AuditTrailActionKey}
        labelKey={AuditTrailActionKey}
        values={values}
        onChange={(updatedValues) => {
            setValues(updatedValues.length > 0 ? updatedValues.map(v => v[AuditTrailActionKey]) : null);
        }}
        onClose={() => {
            onClose(filterMember, AuditTrailActionFilterQueryCondition, values);
        }}
        onClear={() => {
            onClose(filterMember, AuditTrailActionFilterQueryCondition, []);
        }}
    />)
}

export default AuditTrailActionFilterModal;
